export default "/dist/files/rubrique_edito.a246b3e8ce8f9d9ef83bfd0e27ab1515.svg";